import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../../Config/Config';
import { NavLink } from 'react-router-dom';

function Aboute_Area() {
  const [aboutDetail, setAboutDetail] = useState(null);
  const [aboutData, setAboutData] = useState(null);

  useEffect(() => {
    fetch(`${BASE_URL}/AboutUs_detail/`)
      .then((res) => res.json())
      .then((data) => {
        if (data?.data?.length > 0) {
          setAboutDetail(data.data[0]);
        }
      })
      .catch((err) => console.error("Error fetching AboutUs detail data:", err));
  }, []);


  const experienceTexts = ['2', ' ', '4', '+', ' ', 'Y', 'E', 'A', 'R', 'S', ' ', 'E', 'X', 'P', 'E', 'R', 'I', 'E', 'N', 'C', 'E', ' '];
  
    useEffect(() => {
      fetch(`${BASE_URL}/AboutUs/`)
        .then((res) => res.json())
        .then((data) => {
          if (data?.data?.length > 0) {
            setAboutData(data.data[0]);
          }
        })
        .catch((err) => console.error('Error fetching AboutUs data:', err));
    }, []);



  return (
    <>
  <div className="overflow-hidden space" id="about-sec">
      {/* Decorative Shapes */}
      <div className="shape-mockup jump d-md-block d-none" data-right={0} data-bottom="10%">
        <img src="/assets/img/normal/about_2_shape1.png" alt="shapes" />
      </div>
      <div className="shape-mockup jump d-md-block d-none" data-right="76px" data-bottom="10%">
        <img src="/assets/img/normal/about_1_shape1.png" alt="shapes" />
      </div>

      <div className="container">
        <div className="row">
          
          {/* LEFT: Images */}
        

          {/* RIGHT: Text Content */}
          <div className="col-xl-6">
            <div className="about2-title-wrap">
              <div className="title-area mb-30">
                <span className="sub-title">
                  <i className="fal fa-book me-2" />
                  {aboutData?.AboutUs_Top_Line || 'Get to Know About Us'}
                </span>
                <h2 className="sec-title">
                  {aboutData?.AboutUs_heading || 'Welcome to Auratech Academy'}
                </h2>
              </div>

              <p className="mt-n2 mb-35">
                {aboutData?.AboutUs_Home_Description || 'Auratech Academy, established in 2008...'}
              </p>

             <div className="checklist style2 mb-45">
  <ul>
    {aboutData?.highlight_1 && <li>{aboutData.highlight_1}</li>}
    {aboutData?.highlight_2 && <li>{aboutData.highlight_2}</li>}
    {aboutData?.highlight_3 && <li>{aboutData.highlight_3}</li>}
    {aboutData?.highlight_4 && <li>{aboutData.highlight_4}</li>}
  </ul>
</div>

              
{/* {aboutData?.AboutUs_More_Button === 1 && ( */}
  <a href="#about-sec"className="th-btn">
    {aboutData?.AboutUs_More_Button_text} <i className="far fa-arrow-right ms-2" />
  </a>
{/* )} */}

            </div>
          </div>

  <div className="col-xl-6 mb-50 mb-xl-0">
            <div className="img-box2">
              <div className="img1">
                <img
                  src={aboutData ? `${BASE_URL}${aboutData.AboutUs_Home_Image1}` : "/assets/img/about_img.jpg"}
                  alt="About US Auratech Academy"
                />
              </div>
              <div className="img2 tilt-active">
                <img
                  src={aboutData ? `https://api.auratechacademy.com${aboutData.AboutUs_Home_Image2}` : "/assets/img/about_traning.jpg"}
                  alt="About Auratech Academy"
                />
              </div>

              {/* Student Count Section */}
              <div className="tilt-active shape-mockup student-count jump">
                <h5 className="title">
                  <span className="text-theme">
                    <span className="counter-number">{aboutData?.Active_students}</span>
                  </span> 
                </h5>
                <img src={aboutData ? `${BASE_URL}${aboutData?.AboutUs_Home_Image3}` : '/assets/img/about/student_pics.png'} alt="img" />
              </div>

              {/* Experience Section */}
              <div className="about-experience-wrap" style={{ zIndex: 2 }}>
                <div className="about-experience-icon">
                  <img src="/assets/img/icon/AA-Favicon.png" alt="img" />
                </div>
                <div className="about-experience-tag">
                  {experienceTexts.map((text, index) => (
                    <span key={index} className="about-title-anime">
                      <span className={`char${index}`}>{text}</span>
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


      <div className="overflow-hidden bg-smoke space" id="about-sec"  data-bg-src="assets/img/bg/about-5-bg.png">
        <div className="container">
          <div className="row">
            {/* Left Column - Images */}
            <div className="col-xl-6 mb-50 mb-xl-0">
              <div className="img-box4">
                <div className="img1">
                  <img
                    className="tilt-active"
                    src={aboutDetail ? `${BASE_URL}${aboutDetail.AboutUs_detail_Image1}` : "assets/img/normal/about_5_1.png"}
                    alt="About"
                  />
                </div>

                {/* Student Count */}
                <div className="about-grid">
                  <h3 className="about-grid_year">
                    <span className="counter-number">
                      {aboutDetail?.AboutUs_detail_Active_students?.split(" ")[0]}
                      {/* {console.log(aboutDetail?.AboutUs_detail_Active_students?.split(" "))} */}
                    </span>
                  </h3>
                  <p className="about-grid_text">{aboutDetail?.AboutUs_detail_Active_students}</p>
                </div>

                <div className="img2">
                  <img
                    className="tilt-active"
                    src={aboutDetail ? `${BASE_URL}${aboutDetail.AboutUs_detail_Image2}` : "assets/img/normal/about_5_2.png"}
                    alt="About"
                  />
                </div>

                <div className="shape1 shape-mockup jump" data-bottom={0} data-left="-46px">
                  <img
                    src="assets/img/normal/about_5_1shape.png"
                    alt="About"
                  />
                </div>
              </div>
            </div>

            {/* Right Column - Content */}
            <div className="col-xl-6">
              <div className="title-area mb-35">
                <span className="sub-title">
                  <i className="fal fa-book me-2" />
                  {aboutDetail?.AboutUs_detail_Top_Line || "About Our Academy"}
                </span>
                <h2 className="sec-title">{aboutDetail?.AboutUs_detail_heading || "Welcome to Auratech Academy"}</h2>
              </div>

              <p className="mt-n2 mb-25">
                {aboutDetail?.AboutUs_detail_Description ||
                  "Auratech Academy is a premier institution dedicated to high-quality education..."}
              </p>

              <div className="row mb-35 gy-4">
                <div className="col-lg-6">
                  <div className="about-grid3">
                    <div className="about-grid-icon">
                      <img src="/assets/img/icon/about-grid-icon2-1.svg" alt="icon" />
                    </div>
                    <div className="details">
                      <h5>{aboutDetail?.AboutUs_detail_Key_heading_1}</h5>
                      <p>{aboutDetail?.AboutUs_detail_key_sub_heading_1}</p>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="about-grid3">
                    <div className="icon">
                      <img src="/assets/img/icon/about-grid-icon2-2.svg" alt="icon" />
                    </div>
                    <div className="details">
                      <h5>{aboutDetail?.AboutUs_detail_Key_heading_2}</h5>
                      <p>{aboutDetail?.AboutUs_detail_key_sub_heading_2}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Highlights */}
              {(aboutDetail?.AboutUs_detail_highlight_1 ||
                aboutDetail?.AboutUs_detail_highlight_2 ||
                aboutDetail?.AboutUs_detail_highlight_3 ||
                aboutDetail?.AboutUs_detail_highlight_4) && (
                <div className="row align-items-center">
                  <div className="col-md-auto">
                    <div className="about-grid_img mb-30 mb-md-0">
                      <img src={aboutDetail.AboutUs_detail_Image3 && `${BASE_URL}${aboutDetail.AboutUs_detail_Image3}`} alt="img" />
                    </div>
                  </div>
                  <div className="col-md-7">
                    <div className="checklist">
                      <ul>
                        {aboutDetail?.AboutUs_detail_highlight_1 && <li>{aboutDetail.AboutUs_detail_highlight_1}</li>}
                        {aboutDetail?.AboutUs_detail_highlight_2 && <li>{aboutDetail.AboutUs_detail_highlight_2}</li>}
                        {aboutDetail?.AboutUs_detail_highlight_3 && <li>{aboutDetail.AboutUs_detail_highlight_3}</li>}
                        {aboutDetail?.AboutUs_detail_highlight_4 && <li>{aboutDetail.AboutUs_detail_highlight_4}</li>}
                      </ul>
                    </div>
                  </div>
                </div>
              )}

              {/* Add Button if required */}
              {/* <NavLink to="/about" className="th-btn mt-40">ABOUT MORE<i className="fa-regular fa-arrow-right ms-2" /></NavLink> */}
            </div>
          </div>
        </div>
      </div>



    </>
  );
}

export default Aboute_Area;
